import zod from "zod";

export const brandingLogoSchema = zod.object({
  file_url: zod.string().url(),
  id: zod.number().nullable(),
  original_name: zod.string(),
});

export type BrandingLogo = zod.infer<typeof brandingLogoSchema>;

export const brandingSchema = zod.object({
  button_colour: zod.string(),
  button_text_colour: zod.string(),
  colour: zod.string(),
  currency: zod.string(),
  description_font_colour: zod.string(),
  heading_font_colour: zod.string(),
  icon_colour: zod.string(),
  is_default: zod.boolean(),
  label_font_colour: zod.string(),
  locale: zod.string(),
  logo: brandingLogoSchema.nullable(),
  name: zod.string(),
  progress_bar_colour: zod.string(),
});

export type Branding = zod.infer<typeof brandingSchema>;

export type BrandingColours = Omit<
  Branding,
  "logo" | "is_default" | "name" | "currency" | "locale"
>;
